import {Component} from '@angular/core';
@Component({
  selector: 'app-amdocs-route-loader',
  templateUrl: './amdocs-app-route-loader.component.html',
  styleUrls: ['./amdocs-app-route-loader.component.scss']
})
export class AmdocsAppRouteLoaderComponent {
  public assetsPath:string="/assets/icons/";
  constructor() {
    // No dependencies to inject
  }
}
